import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface RearLeftBrakeProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function RearLeftBrake(props: RearLeftBrakeProps) {
  return (
    <svg
      width="110"
      height="16"
      viewBox="0 0 110 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{right: 247, bottom: 74}}
      onClick={props.onClick}
    >
      <path
        d="M3 7H43V15H67V7H77V3H3C3 3 1 3 1 5C1 7 3 7 3 7Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M105 1H93H81C78 1 77 2 77 5C77 8 78 9 81 9H93H105C108 9 109 8 109 5C109 2 108 1 105 1Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M105 1H93H81C78 1 77 2 77 5C77 8 78 9 81 9H93H105C108 9 109 8 109 5C109 2 108 1 105 1Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M77 3H3C3 3 1 3 1 5C1 7 3 7 3 7H77"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <rect
        width="24"
        height="8"
        transform="matrix(1 0 0 -1 43 15)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
    </svg>
  );
}
